import React from "react";
// import { motion } from "framer-motion";
import landingBg from "../images/landing_bg.png";

const LandingSection = () => {
  // Define the background image style using the imported image
  const backgroundStyle = {
    backgroundImage: `url(${landingBg})`, // Use the imported image here
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat", // Prevent image repetition
    height: "100vh", // Full screen height
  };

  return (
    <>
      {/* First Section */}
      <div
        style={backgroundStyle}
        className="relative flex items-center justify-start px-12"
      >
        {/* Main Content */}
        <div className="text-left text-white max-w-screen-lg font-raleway">
          {/* Title */}
          {/* <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          > */}
          <h1
            style={{ lineHeight: "1.2" }}
            className="text-5xl sm:text-5xl font-semibold pl-6 pb-2 pt-4"
          >
            <span className="text-6xl sm:text-7xl">
              Where Purpose Meets Profit:
            </span>{" "}
            <br />
            Become a Founders’ Circle member
          </h1>
          {/* Subtitle */}
          <h3 className="font-thin text-xl sm:text-xl md:text-2xl mb-8 pl-6 text-gray-100 font-inter leading-snug mt-2">
            Unlock New Opportunities, Build Trust, and Elevate Your Brand
          </h3>

          {/* Call to Action Buttons */}
          <div className="pl-6 space-x-4">
            {/* First Button */}
            <button
              className="bg-[#3A6EA5] text-white px-4 py-2 rounded-lg hover:bg-[#004E98] transition"
              onClick={() =>
                document
                  .getElementById("founders-circle")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Become a member of Founders’ Circle
            </button>
          </div>
          {/* </motion.div> */}
        </div>
      </div>
    </>
  );
};

export default LandingSection;
